module.exports = __webpack_public_path__ + "static/media/banner-my-jobs.f5c2a71b.webp";